import React from 'react';
import './styles/global.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Why from './components/Why';
import Offers from './components/Offers';
import TrendingDestinations from './components/TrendingDestinations';
import PropertyTypes from './components/PropertyTypes';
import FeaturedProperties from './components/FeaturedProperties';
import Destinations from './components/Destinations';
import About from './components/About';
import Trust from './components/Trust';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Why />
      <Offers />
      <Destinations />
      <TrendingDestinations />
      <PropertyTypes />
      <FeaturedProperties />
      <About />
      <Trust />
      <Footer />
    </div>
  );
}

export default App;
